import React, {useEffect, useState} from 'react';
import moment, {Moment} from 'moment';
import DateTime from 'react-datetime';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import {RoadmapItem} from '../Services/RoadmapService';
import {RoadmapGroup} from '../Roadmap';

interface EditItemProps {
  item: RoadmapItem;
  groups: RoadmapGroup[];
  update: (item: RoadmapItem) => void;
  remove: (id: number) => void;
  close: () => void;
}

const EditItem = ({
  item,
  groups,
  update,
  remove,
  close,
}: EditItemProps) => {
  const [id, setId] = useState(0);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [group, setGroup] = useState(0);
  const [groupTitle, setGroupTitle] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [groupOpen, setGroupOpen] = useState(false);

  const toggleGroup = () => {
    setGroupOpen(!groupOpen);
  };

  useEffect(() => {
    setId(item.id);
    setStartDate(moment(item.startDate));
    setEndDate(moment(item.endDate));
    setGroup(item.group);
    setTitle(item.title);
    setDescription(item.description);
  }, [item]);

  useEffect(() => {
    const actualGroup = groups.find(g => g.id === group);
    if (actualGroup) {
      setGroupTitle(actualGroup.title);
    }
  }, [group, groups]);

  const saveItem = () => {
    update({
      id,
      group,
      title,
      description,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    });
  };

  const deleteItem = () => {
    remove(id);
  };

  const descriptionChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setDescription(e.currentTarget.value);
  };

  const titleChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setTitle(e.currentTarget.value);
  };

  const endDateChanged = (date: Moment | string) => {
    if (typeof date === 'string') {
      return;
    }

    setEndDate(date);
  };

  const startDateChanged = (date: Moment | string) => {
    if (typeof date === 'string') {
      return;
    }

    setStartDate(date);
  };

  const groupChanged = (id: number) => {
    setGroup(id);
  };

  return (
    <div className="d-flex flex-column align-items-start h-100">
      <div>
        <h2>Edit item</h2>
      </div>
      <div className="flex-grow-1 w-100">
        <div className="form-group row">
          <label className="col-sm-2">Title</label>
          <div className="col-sm-10">
            <input className="form-control" type="text" onChange={titleChanged} value={title} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Description</label>
          <div className="col-sm-10">
            <input className="form-control" type="text" onChange={descriptionChanged} value={description} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Start Date</label>
          <div className="col-sm-10">
            <DateTime value={startDate} onChange={startDateChanged} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">End Date</label>
          <div className="col-sm-10">
            <DateTime value={endDate} onChange={endDateChanged} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2">Group</label>
          <div className="col-sm-10">
            <Dropdown isOpen={groupOpen} toggle={toggleGroup}>
              <DropdownToggle className="dropdown-toggle">{groupTitle}</DropdownToggle>
              <DropdownMenu>
                {groups.map(g => (
                  <DropdownItem
                    key={g.id}
                    onClick={() => groupChanged(g.id)}
                  >
                    {g.title}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="align-self-end">
        <button className="btn btn-primary m-1" onClick={saveItem}>Save</button>
        <button className="btn btn-danger m-1" onClick={deleteItem}>Delete</button>
        <button className="btn btn-secondary m-1" onClick={close}>Cancel</button>
      </div>
    </div>
  );
};

export default EditItem;
